export const normalizeValues = (data) => {
  let normalizedData = { ...data };
  if (data.unitLine === null) {
    normalizedData = { ...normalizedData, unitLine: '' };
  }
  if (data.floor === null) {
    normalizedData = { ...normalizedData, floor: '' };
  }
  return normalizedData;
};

export const checkValidStructure = (data) => {
  if (!data?.length) return ['No data provided'];
  const errors = [];
  data.forEach(({ floor, name }, i) => {
    const currentRow = `row ${i + 1}`;
    if (!floor && !name) {
      errors.push(`${currentRow} cannot be empty`);
    } else if (!floor) {
      errors.push(`floor in ${currentRow} cannot be empty`);
    } else if (!name) {
      errors.push(`name in ${currentRow} cannot be empty`);
    }
  });
  return errors;
};

export const srtSeparateToArray = (nameText) => {
  if (!nameText) return null;
  const names = nameText.split('\n').join(',').split(',');
  const formattedNames = names
    .filter((name) => !!name.trim())
    .map((name) => name.trim());
  return formattedNames;
};
